import { motion } from "motion/react";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Equalizer = ({ className = "" }) => (
  <div className={`flex items-end gap-[3px] h-5 ${className}`} aria-hidden="true">
    {[0, 1, 2, 3, 4].map((i) => (
      <span
        key={i}
        className="eq-bar w-[3px] bg-amberwarm rounded-full"
        style={{
          height: "100%",
          animation: `equalize 1.1s ease-in-out ${i * 0.16}s infinite`,
        }}
      />
    ))}
    <style>{`@keyframes equalize{0%,100%{transform:scaleY(.3)}50%{transform:scaleY(1)}}`}</style>
  </div>
);
